import { render, staticRenderFns } from "./formNotification.vue?vue&type=template&id=5887e761&scoped=true&"
import script from "./formNotification.vue?vue&type=script&lang=js&"
export * from "./formNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5887e761",
  null
  
)

export default component.exports